var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"header-left"},[_c('div',{staticClass:"logos"},[_c('img',{staticClass:"logo",attrs:{"src":require("../../assets/logo.png"),"alt":""},on:{"click":_vm.hanldeClick}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }